import { BrandSubscriptionModel } from 'owa-brands-subscription';
import { assertNever } from 'owa-assert';

export interface GroupedSubscriptions {
    brandSubscriptions: { [key: string]: BrandSubscriptionModel[] };
    subscriptions: { [key: string]: BrandSubscriptionModel[] };
    orderedIds: string[];
}

export default function groupSubscriptions(
    subscriptions: BrandSubscriptionModel[]
): GroupedSubscriptions {
    return subscriptions.reduce(
        (agg, val) => {
            let id: string = null;
            switch (val.type) {
                case 'Subscription':
                    id = val.smtpInfo.smtpIdentifier;
                    agg.subscriptions[id] = [val];
                    break;
                case 'BrandSubscription':
                    id = val.brand.brandId;
                    if (!agg.brandSubscriptions[id]) {
                        agg.brandSubscriptions[id] = [];
                    }

                    agg.brandSubscriptions[id].push(val);
                    break;
                default:
                    return assertNever(val);
            }

            // If the ID was not in the list then add it.
            if (agg.orderedIds.indexOf(id) === -1) {
                agg.orderedIds.push(id);
            }

            return agg;
        },
        {
            brandSubscriptions: {} as { [key: string]: BrandSubscriptionModel[] },
            subscriptions: {} as { [key: string]: BrandSubscriptionModel[] },
            orderedIds: [] as string[],
        }
    );
}
